import axios from "axios";

const endPoint = process.env.REACT_APP_API_SAP;

export const courseDetails = async (data) => {
  const respose = await axios.post(`${endPoint}get-course-details`, data);
  return respose;
};
